"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONE_HUNDRED_PERCENT = exports.ZERO_PERCENT = exports.BETTER_TRADE_LESS_HOPS_THRESHOLD = exports.MAX_HOPS = exports.FACTORY_ABI = exports.ROUTER_ABI = exports.NATIVE_TOKEN_TICKER = exports.MULTICALL_ADDRESS = exports.NATIVE_WRAPPED_TOKEN_ADDRESS = exports.AUTONOMY_MIDROUTER_ADDRESS = exports.AUTONOMY_REGISTRY_ADDRESS = exports.TRADERJOE_INIT_CODE_HASH = exports.TRADERJOE_FACTORY_ADDRESS = exports.TRADERJOE_ROUTER_ADDRESS = exports.APESWAP_INIT_CODE_HASH = exports.APESWAP_FACTORY_ADDRESS = exports.APESWAP_ROUTER_ADDRESS = exports.TRANSACTION_DEADLINE = void 0;
const tslib_1 = require("tslib");
const sdk_core_1 = require("@uniswap/sdk-core");
const IUniswapV2Router02_json_1 = require("@uniswap/v2-periphery/build/IUniswapV2Router02.json");
const IUniswapV2Factory_json_1 = require("@uniswap/v2-periphery/build/IUniswapV2Factory.json");
const JoeRouter02_json_1 = require("@traderjoe-xyz/core/deployments/avalanche/JoeRouter02.json");
const JoeFactory_json_1 = require("@traderjoe-xyz/core/deployments/avalanche/JoeFactory.json");
const jsbi_1 = (0, tslib_1.__importDefault)(require("jsbi"));
const chains_1 = require("./chains");
exports.TRANSACTION_DEADLINE = `0x${(new Date("2050-01-01").valueOf() / 1000).toString(16)}`;
exports.APESWAP_ROUTER_ADDRESS = "0xcF0feBd3f17CEf5b47b0cD257aCf6025c5BFf3b7";
exports.APESWAP_FACTORY_ADDRESS = "0x0841BD0B734E4F5853f0dD8d7Ea041c241fb0Da6";
exports.APESWAP_INIT_CODE_HASH = "0xf4ccce374816856d11f00e4069e7cada164065686fbef53c6167a63ec2fd8c5b";
exports.TRADERJOE_ROUTER_ADDRESS = "0x60aE616a2155Ee3d9A68541Ba4544862310933d4";
exports.TRADERJOE_FACTORY_ADDRESS = "0x9Ad6C38BE94206cA50bb0d90783181662f0Cfa10";
exports.TRADERJOE_INIT_CODE_HASH = "0x0bbca9af0511ad1a1da383135cf3a8d2ac620e549ef9f6ae3a4c33c2fed0af91";
exports.AUTONOMY_REGISTRY_ADDRESS = {
    [chains_1.CHAIN_ID.BSC]: "0x18d087F8D22D409D3CD366AF00BD7AeF0BF225Db",
    [chains_1.CHAIN_ID.AVAX]: "0x68FCbECa74A7E5D386f74E14682c94DE0e1bC56b",
};
exports.AUTONOMY_MIDROUTER_ADDRESS = {
    [chains_1.CHAIN_ID.BSC]: "0xB231B2c7BeA4F767951E79dD5f4973Bc1ADdB189",
    [chains_1.CHAIN_ID.AVAX]: "0xE3e761127cBD037E18186698a2733d1e71623ebE",
};
exports.NATIVE_WRAPPED_TOKEN_ADDRESS = {
    [chains_1.CHAIN_ID.BSC]: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    [chains_1.CHAIN_ID.AVAX]: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
};
exports.MULTICALL_ADDRESS = {
    [chains_1.CHAIN_ID.BSC]: "0x38c4092b28dAB7F3d98eE6524549571c283cdfA5",
    [chains_1.CHAIN_ID.AVAX]: "0x29b6603D17B9D8f021EcB8845B6FD06E1Adf89DE",
};
exports.NATIVE_TOKEN_TICKER = {
    [chains_1.CHAIN_ID.BSC]: "ETH",
    [chains_1.CHAIN_ID.AVAX]: "AVAX",
};
exports.ROUTER_ABI = {
    [chains_1.CHAIN_ID.BSC]: IUniswapV2Router02_json_1.abi,
    [chains_1.CHAIN_ID.AVAX]: JoeRouter02_json_1.abi,
};
exports.FACTORY_ABI = {
    [chains_1.CHAIN_ID.BSC]: IUniswapV2Factory_json_1.abi,
    [chains_1.CHAIN_ID.AVAX]: JoeFactory_json_1.abi,
};
exports.MAX_HOPS = 3;
const BIPS_BASE = jsbi_1.default.BigInt(10000);
exports.BETTER_TRADE_LESS_HOPS_THRESHOLD = new sdk_core_1.Percent(jsbi_1.default.BigInt(50), BIPS_BASE);
exports.ZERO_PERCENT = new sdk_core_1.Percent("0");
exports.ONE_HUNDRED_PERCENT = new sdk_core_1.Percent("1");
